import type { ReactNode } from 'react';

import { Gnb } from './Gnb';

interface AppShellProps {
  children?: ReactNode;
}

// Medical Web v3 shell: dark sticky GNB + full-width main, no LNB.
// Matches prototype/medical-web/prototype/index.html (gnb--v3 + content-wrapper--v3).
export function AppShell({ children }: AppShellProps) {
  return (
    <>
      <Gnb />
      <div className="content-wrapper content-wrapper--v3">
        <main id="content">{children}</main>
      </div>
    </>
  );
}
